export const pageCapacity = {
    loadDone: function (results) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        // 保存ボタンが押されたときの挙動。
        $(".js-submit")
            .off("click")
            .on("click", function () {
                form.disableButtons(this);

                //延長保育なしは時間と備考を空にする
                if ($(".js-extend-childcare:checked").val() !== "1") {
                    $('input[name="startTime[7]"]').val("");
                    $('input[name="endTime[7]"]').val("");
                    $('input[name="startTime[8]"]').val("");
                    $('input[name="endTime[8]"]').val("");
                    $('textarea[name="extendTimeContent"]').val("");
                }
                $(".nursery__side-menu-content").data("editing", "false");
                window.removeEventListener("beforeunload", nursery.saveAlert);
                const url = $("#basicForm").attr("action");
                form.post(url, "#basicForm", "更新が完了しました", () => {
                    pageCapacity.postDone();
                    form.activateButtons(this);
                });
            });

        //延長保育のラジオボタンでコンテンツの表示切替 ※未完成
        $(document)
            .off("change", ".js-extend-childcare")
            .on("change", ".js-extend-childcare", function () {
                if ($(".js-extend-childcare:checked").val() === "1") {
                    $("#js-extended-childcare-time").fadeIn();
                    $("#js-extended-childcare-memo").fadeIn();
                } else {
                    $("#js-extended-childcare-time").fadeOut();
                    $("#js-extended-childcare-memo").fadeOut();
                }
            })
            .find(".js-extend-childcare")
            .trigger("change");

        $(document)
            .off("change", ".js-kindergarten-extend-childcare")
            .on("change", ".js-kindergarten-extend-childcare", function () {
                if ($(".js-kindergarten-extend-childcare:checked").val() === "1") {
                    $("#js-kindergarten-extended-childcare-time").fadeIn();
                    $("#js-kindergarten-extended-childcare-memo").fadeIn();
                } else {
                    $("#js-kindergarten-extended-childcare-time").fadeOut();
                    $("#js-kindergarten-extended-childcare-memo").fadeOut();
                }
            })
            .find(".js-kindergarten-extend-childcare")
            .trigger("change");

        // 一時保育のラジオボタンでコンテンツの表示切替
        $(document)
            .off("change", ".js-short-term-childcare-enabled")
            .on("change", ".js-short-term-childcare-enabled", function () {
                if ($(".js-short-term-childcare-enabled:checked").val() === "1") {
                    $("#js-short-term-childcare-info").fadeIn();
                } else {
                    $("#js-short-term-childcare-info").fadeOut();
                }
            })
            .find(".js-short-term-childcare-enabled")
            .trigger("change");

        // 定員数のラジオボタンでコンテンツの表示切替
        $(document)
            .off("change", ".js-child-capacity-count-type")
            .on("change", ".js-child-capacity-count-type", function () {
                const checked = $(".js-child-capacity-count-type:checked").val();
                const elm = $(".js-child-capacity-count-list");
                if (checked === "0") {
                    // 入力しない
                    elm.fadeOut();
                    return;
                }
                elm.fadeIn();
            })
            .find(".js-child-capacity-count-type")
            .trigger("change");

        // 空き状況のラジオボタンでコンテンツの表示切替
        $(document)
            .off("change", ".js-child-capacity-openings-status")
            .on("change", ".js-child-capacity-openings-status", function () {
                const checked = $(".js-child-capacity-openings-status:checked").val();
                if (checked === "0") {
                    // 入力しない
                    $("#js-child-capacity-openings-count").fadeOut();
                    $("#js-child-capacity-openings-status-count-applies-on").fadeOut();
                    $("#js-child-capacity-openings-status-url").fadeOut();
                } else if (checked === "1") {
                    // 空き数を直接入力
                    $("#js-child-capacity-openings-count").fadeIn();
                    $("#js-child-capacity-openings-status-count-applies-on").fadeIn();
                    $("#js-child-capacity-openings-status-url").fadeOut();
                } else {
                    // 情報記載ページのURL
                    $("#js-child-capacity-openings-count").fadeOut();
                    $("#js-child-capacity-openings-status-count-applies-on").fadeOut();
                    $("#js-child-capacity-openings-status-url").fadeIn();
                }
            })
            .find(".js-child-capacity-openings-status")
            .trigger("change");

        // 今日の日付を入力するボタン
        $(".js-insert-date-button")
            .off("click")
            .on("click", function () {
                const today = new Date();
                const dd = String(today.getDate()).padStart(2, "0");
                const mm = String(today.getMonth() + 1).padStart(2, "0");
                const yyyy = today.getFullYear();
                $('input[type="date"]').val(yyyy + "-" + mm + "-" + dd);
            });

        // フォームに変更があった際、離脱時にアラートを表示
        $("form")
            .off("change")
            .on("change", function () {
                $(".nursery__side-menu-content").data("editing", "true");
                window.addEventListener("beforeunload", nursery.saveAlert);
            });
    },
    // POST完了
    postDone: function (results) {
        $("#js-nav-pagetop").trigger("click");
    }
};
